import _DTO from "./_DTO";

export default class ProtocolDTO extends _DTO {

  constructor(protocol) {
    super();
    this.name = protocol.name;
  }

}
